export default function numberRender(value) {
    return value;
}
